module.exports = __webpack_public_path__ + "static/media/pangolin.bb289ac4.gif";